import React from 'react';
import cn from 'classnames';

import arrowDown from 'assets/svg/arrow-down.svg';
import Icon from '../Icon';
import './datepickerLabel.scss';

interface Props {
    isRight?: boolean;
    placeholderText?: string;
    value?: string;
    onClick?: () => void;
    isOpen?: boolean;
}

const DatepickerLabel: React.FC<Props> = ({
    value,
    isRight,
    placeholderText,
    onClick,
    isOpen,
}) => {
    return (
        <div
            styleName={cn('container', {
                'has-value': !!value,
                'is-right': !!isRight,
            })}
            className="__app-Label-container"
            onClick={onClick}
        >
            <div>{value || placeholderText}</div>
            <Icon
                styleName={cn('icon', {
                    'is-open': isOpen,
                })}
                glyph={arrowDown}
            />
        </div>
    );
};

export default DatepickerLabel;
